import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import RequireAuth from './components/RequireAuth';
import Login from './pages/Login';
import Imports from './pages/Imports';
import BatchDetail from './pages/BatchDetail';
import CarriersPage from './pages/CarriersPage';
import Agents from './pages/Agents';
import MappingsCarrier from './pages/MappingsCarrier';
import Pay from './pages/Pay';
import Payments, { PaymentDetail } from './pages/Payments';
import PayRuns, { PayRunDetail } from './pages/PayRuns';
import Users from './pages/Users';
import Search from './pages/Search';
import MyDashboard from './pages/agent/MyDashboard';
import MyPayments, { MyPaymentDetail } from './pages/agent/MyPayments';
import MyCarriers, { MyCarrierDetail } from './pages/agent/MyCarriers';
import Pivot from './pages/Pivot';
import Reports from './pages/Reports';
import PayCycle from './pages/PayCycle';

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />

      {/* Authenticated */}
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Navigate to="/cycle" replace />} />
          {/* Admin */}
          <Route path="/:sys/imports" element={<Imports />} />
          <Route path="/:sys/batches/:batchId" element={<BatchDetail />} />
          <Route path="/:sys/carriers" element={<CarriersPage />} />
          <Route path="/:sys/carriers/:carrier" element={<CarriersPage />} />
          {/* Legacy /mappings URLs — redirect to the new tabbed Carriers page */}
          <Route path="/:sys/mappings" element={<Navigate to="../carriers" replace relative="path" />} />
          <Route path="/:sys/mappings/:carrier" element={<MappingsCarrier />} />
          <Route path="/:sys/pay" element={<Pay />} />
          <Route path="/:sys/pay-runs" element={<PayRuns />} />
          <Route path="/:sys/pay-runs/:payRunId" element={<PayRunDetail />} />
          <Route path="/:sys/payments" element={<Payments />} />
          <Route path="/:sys/payments/:paymentId" element={<PaymentDetail />} />
          <Route path="/:sys/agents" element={<Agents />} />
          {/* /setup is gone — adding a new carrier is a code change. Old links redirect to Carriers. */}
          <Route path="/:sys/setup" element={<Navigate to="../carriers" replace relative="path" />} />
          <Route path="/:sys/setup/:carrier" element={<Navigate to="../../carriers" replace relative="path" />} />
          <Route path="/:sys/policy-data" element={<Pivot />} />
          <Route path="/:sys/reports" element={<Reports />} />
          {/* Legacy /pivot URL — redirect for any bookmarks */}
          <Route path="/:sys/pivot" element={<Navigate to="../policy-data" replace relative="path" />} />
          <Route path="/cycle" element={<PayCycle />} />
          <Route path="/users" element={<Users />} />
          <Route path="/search" element={<Search />} />
          {/* Agent portal */}
          <Route path="/my" element={<MyDashboard />} />
          <Route path="/my/dashboard" element={<MyDashboard />} />
          <Route path="/my/payments" element={<MyPayments />} />
          <Route path="/my/payments/:paymentId" element={<MyPaymentDetail />} />
          <Route path="/my/carriers" element={<MyCarriers />} />
          <Route path="/my/carriers/:sys/:carrier" element={<MyCarrierDetail />} />
          <Route path="*" element={<Navigate to="/cycle" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
